import { defineComponent as _defineComponent } from 'vue'
import { GeoObjectType } from 'farmdok-rest-api';
import { onMounted, ref } from 'vue';

import googleMapsApi from '@/shared/modules/googleMapsApi';


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleMapLabel',
  props: {
    position: null,
    label: null,
    map: null,
    objectType: null
  },
  setup(__props: any) {

const props = __props as {
  position: google.maps.LatLng;
  label: string;
  map: google.maps.Map;
  objectType: GeoObjectType;
}



const labelPosition = ref({ top: '0px', left: '0px' });

onMounted(async () => {
  const google = await googleMapsApi();

  const overlay: google.maps.OverlayView = new google.maps.OverlayView();

  overlay.setMap(props.map);
  overlay.onRemove = () => null;
  overlay.onAdd = () => null;
  overlay.draw = () => {
    if (overlay) {
      const point = overlay.getProjection().fromLatLngToContainerPixel(props.position);

      const x = point?.x ?? 0;
      const y = point?.y ?? 0;

      const pos = {
        top: `${y - 20}px`,
        left: `${x + 10}px`,
      };

      labelPosition.value = pos;
    }
  };
});

return { __sfc: true,props, labelPosition, GeoObjectType }
}

})